import { FORM_ITEM_CHECKBOX } from "../../../components/Form/FormItems/FormItemCheckbox";
import { FORM_ITEM_RESOURCE_SELECT_LAZY_LOADING } from "../../../components/Form/FormItems/FormItemResourceSelectLazyLoading";
import { FORM_ITEM_TEXT_AREA } from "../../../components/Form/FormItems/FormItemTextArea";

/**
 * Builds the provider and metadata field descriptors for the training form.
 * Covers: Provider type (internal/external), External Provider company selector,
 * Responsible person selector, Internal remarks, and Active checkbox.
 */
export const buildProviderFields = ({ data, isNewRecord, internalProvider, setInternalProvider }) => [
  {
    required: true,
    type: FORM_ITEM_RESOURCE_SELECT_LAZY_LOADING,
    name: "internal_provider",
    label: "trg.new_training.provider",
    placeholder: "trg.new_training.provider",
    fieldProps: {
      onChange: (value) => setInternalProvider(value),
      staticOptions: [
        { transKey: "trg.new_training.internal", value: 1 },
        { transKey: "trg.new_training.external", value: 0 }
      ]
    }
  },
  {
    required: true,
    type: FORM_ITEM_RESOURCE_SELECT_LAZY_LOADING,
    name: "external_provider_id",
    label: "trg.new_training.provider_name",
    placeholder: "trg.new_training.provider_name",
    visible: internalProvider === 0,
    apiRoute:
      "trg/external-providers?field%5B%5D=active&op%5B%5D=eq&order_by_column%5B%5D=name&order_by_type%5B%5D=asc&term%5B%5D=1",
    fieldProps: {
      requestOnMount: !isNewRecord
    }
  },
  {
    required: true,
    type: FORM_ITEM_RESOURCE_SELECT_LAZY_LOADING,
    name: "responsible_id",
    label: "trg.new_training.responsible_person",
    placeholder: "trg.new_training.responsible_person",
    visible: !!internalProvider,
    apiRoute:
      "users/all?field%5B%5D=user_is_in_organisation&filters%5BvalidContract%5D=1&op%5B%5D=eq&order_by_column%5B%5D=name&order_by_type%5B%5D=asc&term%5B%5D=1",
    fieldProps: {
      requestOnMount: !isNewRecord,
      searchColumns: ["name"]
    }
  },
  {
    type: FORM_ITEM_TEXT_AREA,
    name: "internal_remarks",
    label: "trg.new_training.internal_remarks",
    placeholder: "trg.new_training.internal_remarks",
    autoSize: { minRows: 2, maxRows: 6 },
    fieldProps: {
      disabled: !!data.shared_by_company_name
    }
  },
  {
    type: FORM_ITEM_CHECKBOX,
    visible: isNewRecord,
    name: "active",
    label: "trg.external_providers.active"
  }
];
